<template>
  <v-footer
    app
    tile
    fixed
    color="#131313"
    class="justify-space-around"
    v-if="isAuthenticated"
  >
    <v-btn
      small
      fab
      icon
      v-for="button in buttons"
      :key="button.title"
      :to="button.route"
    >
      <!-- <span>{{ button.title }}</span> -->
      <v-icon small>{{ button.icon }}</v-icon>
    </v-btn>
  </v-footer>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "BottomNav",
  data: () => ({
    buttons: [
      { title: "Money", icon: "mdi-wallet-outline", route: "/money" },
      { title: "Activity", icon: "mdi-heart-pulse", route: "/activity" },
      { title: "Food", icon: "mdi-silverware-fork-knife", route: "/food" },
      { title: "Dashboard", icon: "mdi-chart-line", route: "/dash" },
      { title: "Grid", icon: "mdi-view-list", route: "/grid" },
      { title: "Edit", icon: "mdi-square-edit-outline", route: "/edit" },
      { title: "SignOut", icon: "mdi-logout-variant", route: "/" }
    ]
  }),
  computed: {
    ...mapState({
      isAuthenticated: state => state.auth.isAuthenticated
    })
  }
};
</script>

<style lang="scss" scoped></style>
